import React from "react";
import styles from "../../../Admin/widget/WidgetAnalytics.module.css";
import { FiGlobe, FiActivity, FiEye, FiMessageSquare, FiSmartphone, FiMessageCircle } from "react-icons/fi";

const fmt = (n) => n.toLocaleString();
const STAT_ICONS = [FiGlobe, FiActivity, FiEye, FiMessageSquare, FiSmartphone, FiMessageCircle];

const SkeletonStatCard = () => (
  <div className={styles.skeletonStatCard}>
    <div className={styles.skeletonStatTop}>
      <div className={styles.skeletonDotLabel}>
        <div className={`${styles.skeleton} ${styles.skeletonDot}`} />
        <div className={styles.skeleton} style={{ height: "9px", width: "70%" }} />
      </div>
      <div className={styles.skeleton} style={{ height: "20px", width: "46px", borderRadius: "20px" }} />
    </div>
    <div className={styles.skeleton} style={{ height: "20px", width: "55%", marginBottom: "8px" }} />
    <div className={styles.skeleton} style={{ height: "9px", width: "80%" }} />
  </div>
);

const StatsRow = ({ stats, loading }) => (
  <div className="row mb-4">
    {loading
      ? Array.from({ length: 6 }).map((_, i) => (
          <div className="col-6 col-sm-4 col-md mb-3" key={i}><SkeletonStatCard /></div>
        ))
      : stats.map((s, i) => {
          const isNeg = s.change && s.change.startsWith("-");
          return (
            <div className="col-6 col-sm-4 col-md mb-3" key={i}>
              <div className={styles.statCard}>
                <div className={styles.statDotLabel}>
                  <span className={styles.statIconWrap}>
                    {React.createElement(STAT_ICONS[i], { size: 13 })}
                  </span>
                  <span className={styles.statLabel}>{s.label}</span>
                </div>
                <div className={styles.statValueRow}>
                  <div className={styles.statValue}>{fmt(s.value)}</div>
                  {s.change && (
                    <span className={isNeg ? styles.statBadgeNeg : styles.statBadge}>{s.change}</span>
                  )}
                </div>
                <div className={styles.statDesc}>{s.desc}</div>
              </div>
            </div>
          );
        })
    }
  </div>
);

export default StatsRow;
